module.exports = __webpack_public_path__ + "static/img/reports-hero.d0a6280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v5/reports-hero.png
// module id = E2Sm
// module chunks = 0